define(
  'galleryPageImagesHandler',[
    'builderShowcaseGalleryImagesHandler',
    'galleryPageMoreResultsHandler',
    'galleryModalHandler',
  ],
  (
    builderShowcaseGalleryImagesHandler,
    galleryPageMoreResultsHandler,
  ) => {
    'use strict';

    /**
     * Clears the container from any existing image.
     */
    function clearImageCollections() {
      const container = document.querySelector('[data-section-gallery-images]');
      container.innerHTML = '';
    }

    /**
     * Used to get the items from the DOM's template
     * @param {string} category the category being created.
     * @returns The list of images for that category.
     */
    function getCollectionFromTemplate(category) {
      const template = document.querySelector('[data-gallery-collections]');
      const collections = JSON.parse(template.innerHTML);
      let result;

      collections.forEach((collection) => {
        if (collection.Category === category) {
          result = collection;
        }
      });

      return result;
    }

    /**
     * Function used to observe the document and wait for a new page.
     */
    function waitForNewPage() {
      const container = document.querySelector('[data-section-gallery-images]');
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.id === 'nhs_gallery_newpage') {
              observer.disconnect();
              // eslint-disable-next-line no-use-before-define
              createIntersectionObserverTarget();
            }
          });
        });
      });

      observer.observe(container, { subtree: true, childList: true });
    }

    /**
     * Creates a new element at the end of the gallery to observe.
     * @param {Number} page the page to be loaded
     */
    function createIntersectionObserverTarget() {
      const container = document.querySelector('[data-section-gallery-images]');
      const target = document.createElement('div');
      const url = galleryPageMoreResultsHandler.createMoreResultsUrl();

      if (url) {
        target.setAttribute('data-url', url);

        // Prevent the elements from being added into the target element to prevent breaking the grid.
        target.dataset.preventLazyLoadSectionDefaultBehavior = true;
        target.classList.add('gallery__images', 'gallery__images--subpage');
        container.appendChild(target);
        galleryPageMoreResultsHandler.observe(target);
        waitForNewPage();
      }
    }

    /**
     * Used to create the images for the collection
     * @param {string} category the category being created
     */
    function createImageCollection(category) {
      const collection = getCollectionFromTemplate(category);

      clearImageCollections();
      builderShowcaseGalleryImagesHandler.createGallerySection(collection);
      createIntersectionObserverTarget();
    }

    return {
      createImageCollection,
    };
  }
);

